<div fxLayout="row" fxLayoutAlign="start center">
    <div>Allow to send notifications?</div>
    <button mat-button (click)=sendYes()>Yes</button>
    <button mat-button (click)="sendNo()">No</button>
</div>
